import { StationPlacementType } from '~types';

export enum PINNING_STEP {
  START = 'START',
  FIND_VENUE = 'FIND_VENUE',
  CREATE_VENUE_ADD_NAME = 'CREATE_VENUE_ADD_NAME',
  CREATE_VENUE_ADD_VENUE_TYPE = 'CREATE_VENUE_ADD_VENUE_TYPE',
  CREATE_VENUE_ADD_VENUE_SUB_TYPE = 'CREATE_VENUE_ADD_VENUE_SUB_TYPE',
  CREATE_VENUE_ADD_ADDRESS = 'CREATE_VENUE_ADD_ADDRESS',
  CREATE_VENUE_ADD_CONTACT = 'CREATE_VENUE_ADD_CONTACT',
  CREATE_VENUE_ADD_EMAIL = 'CREATE_VENUE_ADD_EMAIL',
  CREATE_VENUE_ADD_PHONE_NUM = 'CREATE_VENUE_ADD_PHONE_NUM',

  ASSIGN_STATION_SCAN_QR = 'ASSIGN_STATION_SCAN_QR',
  ASSIGN_STATION_SELECT_STATION = 'ASSIGN_STATION_SELECT_STATION',
  ASSIGN_STATION_ADD_PLACEMENT_NAME = 'ASSIGN_STATION_ADD_PLACEMENT_NAME',
  ASSIGN_STATION_ADD_PLACEMENT_TYPE = 'ASSIGN_STATION_ADD_PLACEMENT_TYPE',
  ASSIGN_STATION_ADD_DISTRIBUTION_CHANNEL = 'ASSIGN_STATION_ADD_DISTRIBUTION_CHANNEL',
  ASSIGN_STATION_PIN_COORDINATES = 'ASSIGN_STATION_PIN_COORDINATES',
  ASSIGN_STATION_UPLOAD_PHOTOS = 'ASSIGN_STATION_UPLOAD_PHOTOS',

  REVIEW_CONFIRM = 'REVIEW_CONFIRM',
  VENUE_DETAIL_REVIEW = 'VENUE_DETAIL_REVIEW',
  PLACEMENT_DETAIL_REVIEW = 'PLACEMENT_DETAIL_REVIEW',
  CONFIRM_VENUE = 'CONFIRM_VENUE',
  ASSIGN_STATION_SELECT_EXISTING_PLACEMENT = 'ASSIGN_STATION_SELECT_EXISTING_PLACEMENT',
  CONFIRM_SWAP_STATION = 'CONFIRM_SWAP_STATION',
  ASSIGN_STATION_SELECT_ACTION = 'ASSIGN_STATION_SELECT_ACTION',
  CONFIRM_RELOCATION = 'CONFIRM_RELOCATION',
}

export const VENUE_CONTACT_STEPS = [
  PINNING_STEP.CREATE_VENUE_ADD_CONTACT,
  PINNING_STEP.CREATE_VENUE_ADD_EMAIL,
  PINNING_STEP.CREATE_VENUE_ADD_PHONE_NUM,
];

export const requiredStepsInPinning = [
  PINNING_STEP.CREATE_VENUE_ADD_NAME,
  PINNING_STEP.CREATE_VENUE_ADD_VENUE_TYPE,
  PINNING_STEP.CREATE_VENUE_ADD_VENUE_SUB_TYPE,
  PINNING_STEP.CREATE_VENUE_ADD_ADDRESS,
  PINNING_STEP.CREATE_VENUE_ADD_CONTACT,
  PINNING_STEP.CREATE_VENUE_ADD_EMAIL,
  PINNING_STEP.CREATE_VENUE_ADD_PHONE_NUM,

  PINNING_STEP.ASSIGN_STATION_SCAN_QR,
  PINNING_STEP.ASSIGN_STATION_SELECT_STATION,
  PINNING_STEP.ASSIGN_STATION_ADD_PLACEMENT_NAME,
  PINNING_STEP.ASSIGN_STATION_ADD_PLACEMENT_TYPE,
  PINNING_STEP.ASSIGN_STATION_ADD_DISTRIBUTION_CHANNEL,
  PINNING_STEP.ASSIGN_STATION_PIN_COORDINATES,
  PINNING_STEP.CONFIRM_SWAP_STATION,
  PINNING_STEP.ASSIGN_STATION_UPLOAD_PHOTOS,

  PINNING_STEP.REVIEW_CONFIRM,
];

export const stepTitles: Record<PINNING_STEP, string | null> = {
  [PINNING_STEP.START]: null,
  [PINNING_STEP.FIND_VENUE]: 'Find venue',
  [PINNING_STEP.CREATE_VENUE_ADD_NAME]: 'Create a new venue',
  [PINNING_STEP.CREATE_VENUE_ADD_VENUE_TYPE]: 'Create a new venue',
  [PINNING_STEP.CREATE_VENUE_ADD_VENUE_SUB_TYPE]: 'Create a new venue',
  [PINNING_STEP.CREATE_VENUE_ADD_ADDRESS]: 'Create a new venue',
  [PINNING_STEP.CREATE_VENUE_ADD_CONTACT]: 'Create a new venue',
  [PINNING_STEP.CREATE_VENUE_ADD_EMAIL]: 'Create a new venue',
  [PINNING_STEP.CREATE_VENUE_ADD_PHONE_NUM]: 'Create a new venue',
  [PINNING_STEP.CONFIRM_VENUE]: 'Confirm venue',

  [PINNING_STEP.ASSIGN_STATION_SCAN_QR]: 'Assign a station',
  [PINNING_STEP.ASSIGN_STATION_SELECT_STATION]: 'Select station',
  [PINNING_STEP.ASSIGN_STATION_SELECT_EXISTING_PLACEMENT]: 'Select a placement',
  [PINNING_STEP.ASSIGN_STATION_ADD_PLACEMENT_NAME]: 'Assign a station',
  [PINNING_STEP.ASSIGN_STATION_ADD_PLACEMENT_TYPE]: 'Assign a station',
  [PINNING_STEP.ASSIGN_STATION_ADD_DISTRIBUTION_CHANNEL]: 'Assign a station',
  [PINNING_STEP.ASSIGN_STATION_PIN_COORDINATES]: 'Assign a station',
  [PINNING_STEP.ASSIGN_STATION_UPLOAD_PHOTOS]: 'Upload Station Photos',

  [PINNING_STEP.REVIEW_CONFIRM]: 'Review and confirm',
  [PINNING_STEP.VENUE_DETAIL_REVIEW]: 'Venue details',
  [PINNING_STEP.PLACEMENT_DETAIL_REVIEW]: 'Placement details',
  [PINNING_STEP.CONFIRM_SWAP_STATION]: 'Swap station',
  [PINNING_STEP.ASSIGN_STATION_SELECT_ACTION]: 'Select an action',
  [PINNING_STEP.CONFIRM_RELOCATION]: 'Relocate station',
};

export const stepButtonLabelMap: Partial<Record<PINNING_STEP, string>> = {
  [PINNING_STEP.ASSIGN_STATION_SELECT_STATION]: 'Continue',
  [PINNING_STEP.CONFIRM_SWAP_STATION]: 'Proceed to swap',
  [PINNING_STEP.CONFIRM_RELOCATION]: 'Proceed to relocate',
  [PINNING_STEP.ASSIGN_STATION_UPLOAD_PHOTOS]: 'Continue',
};

export const initialContextValues = {
  selectedVenueId: '' as string | undefined,
  handleSetSelectedVenueId: (_: string | undefined) => {
    return;
  },
  selectedGooglePlaceId: '' as string | undefined,
  handleSetSelectedGooglePlaceId: (_: string | undefined) => {
    return;
  },
  selectedPlacementId: '' as string | undefined,
  handleSetSelectedPlacementId: (_: string | undefined) => {
    return;
  },
  existingPlacements: [] as StationPlacementType[],
  onSearchExistingPlacement: (_: string) => {
    return;
  },
  isLoadingPlacements: false,
  isHavingExistingPlacement: false,
  setIsPlacementAssignedStation: (_: boolean) => {
    return;
  },
  assignedStationId: '' as string | undefined,
  assignedStationImei: '' as string | undefined,
  assignedStationType: '' as string | undefined,
  setAssignedStationId: (_: string | undefined) => {
    return;
  },
  setAssignedStationImei: (_: string | undefined) => {
    return;
  },
  setAssignedStationType: (_: string | undefined) => {
    return;
  },
  swapReasonId: '' as string,
  setSwapReasonId: (_: string) => {
    return;
  },
  relocationReasonId: '' as string,
  setRelocationReasonId: (_: string) => {
    return;
  },
  swapNote: '' as string,
  setSwapNote: (_: string) => {
    return;
  },
  relocationNote: '' as string,
  setRelocationNote: (_: string) => {
    return;
  },
  isRelocationFlow: false,
  setIsRelocationFlow: (_: boolean) => {
    return;
  },
  isAssigningToExistingPlacement: false,
  setIsAssigningToExistingPlacement: (_: boolean) => {
    return;
  },
  isPlacementAssignedStation: false,
  pinningStep: PINNING_STEP.START,
  handleSetPinningStep: (_: PINNING_STEP) => {
    return;
  },
  goToNextStep: () => {
    return;
  },
  goToPreviousStep: () => {
    return;
  },
  getTitleOfCurrentStep: () => {
    return null as string | null;
  },
  requiredStepsInPinning: [] as PINNING_STEP[],
  progress: '0%' as string | null,

  isUpdating: false,
  setIsUpdating: (_: boolean) => {
    return;
  },
  isAddingFromReview: false,
  setIsAddingFromReview: (_: boolean) => {
    return;
  },
  contactSkippedStep: undefined as PINNING_STEP | undefined,
  handleSetContactSkippedStep: (_: PINNING_STEP | undefined) => {
    return;
  },
  skipVenueContact: () => {
    return;
  },
};
